const init = function () {

    const pages = [
        '[data-page="invoices_expense"]',
        '[data-page="invoices_income"]',
        '[data-page="invoices_invoice"]'
    ];

    const hasPage = pages.some(selector => document.querySelector(selector));
    if (!hasPage) {
        return;
    }

    const rows = document.querySelector('#items-table tbody');

    let counter = 0;

    const text = function (value) {
        return String(value ?? '')
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;');
    };

    const number = function (value, fallback = 0) {
        const parsed = Number(value);
        return Number.isFinite(parsed) ? parsed : fallback;
    };

    const getProductField = function (field, fallback = '') {
        return document.querySelector(`[data-mn-product-${field}]`)?.value ?? fallback;
    };

    const setSelectedPrice = function () {
        const selected = document.querySelector('select#priceType')?.value || '1';
        const hiddenInput = document.querySelector(`[name="product-Cena_${selected}"]`);
        if (hiddenInput) {
            document.getElementById('product-price').value = hiddenInput.value || 0;
        }
    };

    const syncCurrencyName = function () {
        const select = document.getElementById('invoice-currency');
        const hidden = document.getElementById('invoice-currency-name');
        if (select && hidden) {
            hidden.value = select.selectedOptions[0]?.dataset.name || select.selectedOptions[0]?.textContent?.trim() || 'грн';
        }
    };

    syncCurrencyName();
    document.getElementById('invoice-currency')?.addEventListener('change', syncCurrencyName);


    document.addEventListener('picker-dblclick', function (event) {
        if (event.detail.type == "products") {
            const select = document.querySelector('select#priceType');
            if (select && select.options.length > 0) {
                const clientPrice = number(document.getElementById('client-price-category')?.value, 1);
                select.value = String(Math.min(Math.max(clientPrice, 1), 14));
                if (!select.value) {
                    select.selectedIndex = 0;
                }
            }
            setSelectedPrice();
            const lengthEl = document.querySelector("#product-length");
            if (lengthEl) lengthEl.value = "0";

            const widthEl = document.querySelector("#product-width");
            if (widthEl) widthEl.value = "0";

            const noteEl = document.querySelector("#product-note");
            if (noteEl) noteEl.value = "";
        }

        if (event.detail.type == "clients") {
            const clientNote = document.querySelector("[name='Primechanie']");
            if (clientNote) clientNote.value = "";
            loadActiveClientTab();
        }


    });

    document.getElementById('priceType')?.addEventListener('change', setSelectedPrice);


    document.getElementById('add-item')?.addEventListener('click', () => {
        addItemToTable({
            name: document.getElementById('product-name').value.trim(),
            price: Number(document.getElementById('product-price').value || 0),
            qty: Number(document.getElementById('product-qty').value || 0),
            unit: document.getElementById('product-unit').value || 'шт',
            note: document.getElementById('product-note')?.value || '',
            length: Number(document.getElementById('product-length')?.value || 0),
            width: document.getElementById('product-width')?.value || '0',
            id_tovar: document.getElementById('selectedProduct')?.value || '0',
            price_slot: document.getElementById('priceType')?.value || '1',
            cut_price: document.getElementById('product-cut-price')?.checked ? 1 : 0,
            koef: getProductField('Koef', 0),
            konfig: getProductField('Konfig', 0),
            uchitivat: getProductField('Uchitivat', 1),
            valuta: getProductField('valuta', 0),
        });
    });

    function addItemToTable(data) {
        if (!data.name || data.qty <= 0) {
            alert("Сначала выберете товар");
            return;
        }
        const total = data.price * data.qty;
        const index = counter++;
        const tr = document.createElement('tr');

        if (window.isIncomeInvoice) {
            tr.innerHTML = `
                <td>${index + 1}</td>
                <td>
                    ${text(data.name)}
                    <input type="hidden" name="items[${index}][id_tovar]" value="${text(data.id_tovar || 0)}">
                    <input type="hidden" name="items[${index}][Tovar]" value="${text(data.name)}">
                </td>
                <td>${text(data.unit)}<input type="hidden" name="items[${index}][Ed_izm]" value="${text(data.unit)}"></td>
                <td>${text(data.length)}<input type="hidden" name="items[${index}][Dlina]" value="${text(data.length)}"></td>
                <td>${text(data.width)}<input type="hidden" name="items[${index}][Shirina]" value="${text(data.width)}"></td>
                <td>${text(data.price)}<input type="hidden" name="items[${index}][Cena]" value="${text(data.price)}"></td>
                <td>${text(data.qty)}<input type="hidden" name="items[${index}][Kolichestvo]" value="${text(data.qty)}"></td>
                <td>${total.toFixed(2)}</td>
                <td><button type="button" class="btn btn-sm btn-outline-danger">x</button></td>
            `;
        } else {
            tr.innerHTML = `
                <td>${index + 1}</td>
                <td>
                    ${text(data.name)}
                    <input type="hidden" name="items[${index}][id_tovar]" value="${text(data.id_tovar || 0)}">
                    <input type="hidden" name="items[${index}][Tovar]" value="${text(data.name)}">
                    <input type="hidden" name="items[${index}][price_slot]" value="${text(data.price_slot || 1)}">
                    <input type="hidden" name="items[${index}][Cena_porezke]" value="${text(data.cut_price || 0)}">
                    <input type="hidden" name="items[${index}][Koef]" value="${text(data.koef || 0)}">
                    <input type="hidden" name="items[${index}][Konfig]" value="${text(data.konfig || 0)}">
                    <input type="hidden" name="items[${index}][Uchitivat]" value="${text(data.uchitivat || 1)}">
                    <input type="hidden" name="items[${index}][valuta]" value="${text(data.valuta || 0)}">
                </td>
                <td>${text(data.unit)}<input type="hidden" name="items[${index}][Ed_izm]" value="${text(data.unit)}"></td>
                <td>${text(data.length)}<input type="hidden" name="items[${index}][Dlina]" value="${text(data.length)}"></td>
                <td>${text(data.width)}<input type="hidden" name="items[${index}][Shirina]" value="${text(data.width)}"></td>
                <td>${total.toFixed(2)}</td>
                <td>${text(data.qty)}<input type="hidden" name="items[${index}][Kolichestvo]" value="${text(data.qty)}"></td>
                <td>${text(data.price)}<input type="hidden" name="items[${index}][Cena]" value="${text(data.price)}"></td>
                <td>${data.cut_price ? 'Порезка' : 'Целая'}</td>
                <td>${text(data.note || '')}<input type="hidden" name="items[${index}][Primechanie]" value="${text(data.note || '')}"></td>
                <td><button type="button" class="btn btn-sm btn-outline-danger">x</button></td>
            `;
        }

        tr.querySelector('button').addEventListener('click', () => {
            tr.remove();
            updateTotal();
        });

        rows.appendChild(tr);
        updateTotal();
    }

    const form = document.getElementById('invoice-form');
    if (form && form.dataset.existingItems) {
        try {
            window.existingItems = JSON.parse(form.dataset.existingItems);
        } catch (e) {
            console.error("Error parsing existing items", e);
        }
    }

    if (window.existingItems && Array.isArray(window.existingItems)) {
        window.existingItems.forEach(item => {
            addItemToTable({
                name: item.Tovar,
                price: item.Cena,
                qty: item.Kolichestvo,
                unit: item.Ed_izm,
                note: item.Primechanie,
                length: item.Dlina,
                width: item.Shirina,
                id_tovar: item.id_tovar,
                price_slot: item.price_slot || 1,
                cut_price: item.Cena_porezke || 0,
                koef: item.Koef || 0,
                konfig: item.Konfig || 0,
                uchitivat: item.Uchitivat ?? 1,
                valuta: item.valuta || 0,
            });
        });
    }

    function updateTotal() {
        let total = 0;
        const totalIdx = window.isIncomeInvoice ? 7 : 5;
        rows.querySelectorAll('tr').forEach((row) => {
            total += Number(row.children[totalIdx]?.textContent || 0);
        });

        const discount = Math.min(Math.max(number(document.getElementById('invoice-discount')?.value, 0), 0), 100);
        document.getElementById('invoice-total').textContent = (total - total * discount / 100).toFixed(2);
    }

    document.getElementById('invoice-discount')?.addEventListener('input', updateTotal);

    function activeClientId() {
        return document.getElementById('client-id')?.value;
    }

    function loadActiveClientTab() {
        const active = document.querySelector('[data-client-tab].active')?.dataset.clientTab;
        if (active === 'discounts') {
            loadClientDiscounts();
        }
        if (active === 'requisites') {
            loadClientRequisites();
        }
    }

    function loadClientDiscounts() {
        const body = document.getElementById('client-discounts-body');
        const clientId = activeClientId();
        if (!body || !clientId) {
            return;
        }

        body.innerHTML = '<tr><td colspan="5" class="text-center">Загрузка...</td></tr>';

        fetch(`/admin/expense-invoices/client/${encodeURIComponent(clientId)}/discounts`)
            .then(res => res.json())
            .then(response => {
                const items = response.items || [];
                if (items.length === 0) {
                    body.innerHTML = '<tr><td colspan="5" class="text-center">Скидок нет</td></tr>';
                    return;
                }

                body.innerHTML = items.map(item => `
                    <tr>
                        <td>${text(item.group_name)}</td>
                        <td>${text(item.skidka_celaya)}%</td>
                        <td>${text(item.skidka_porezka)}%</td>
                        <td>${text(item.skidka_metal)}%</td>
                        <td>${text(item.skidka)}%</td>
                    </tr>
                `).join('');
            })
            .catch(() => {
                body.innerHTML = '<tr><td colspan="5" class="text-center text-danger">Ошибка загрузки</td></tr>';
            });
    }

    function loadClientRequisites() {
        const body = document.getElementById('client-requisites-body');
        const clientId = activeClientId();
        if (!body || !clientId) {
            return;
        }

        body.textContent = 'Загрузка...';

        fetch(`/admin/expense-invoices/client/${encodeURIComponent(clientId)}/requisites`)
            .then(res => res.json())
            .then(response => {
                const item = response.item || {};
                body.textContent = [
                    item.Organization,
                    item.Direktor,
                    item.Ur_adres,
                    item.Fakt_adres,
                    item.Rekvizit,
                    item.Email,
                    item.Tel,
                ].filter(Boolean).join('\n') || 'Реквизиты не заполнены';
            })
            .catch(() => {
                body.textContent = 'Ошибка загрузки';
            });
    }

    document.querySelectorAll('[data-client-tab]').forEach(tab => {
        tab.addEventListener('click', () => {
            document.querySelectorAll('[data-client-tab]').forEach(item => item.classList.toggle('active', item === tab));
            document.querySelectorAll('[data-client-panel]').forEach(panel => {
                panel.hidden = panel.dataset.clientPanel !== tab.dataset.clientTab;
            });
            loadActiveClientTab();
        });
    });

}
export default {init};
